import axios from "axios";
import useConstants from "constants";

const useAuth = () => {
  const { AUTH_API_URL, AUTH_URL, ERM_APP_URL } = useConstants();

  const BASE_URL = AUTH_API_URL;

  const saveTokens = (tokens) => {
    localStorage.setItem("__at_um", tokens.access);
    localStorage.setItem("__rt_um", tokens.refresh);
  };

  const user =
    sessionStorage.getItem("user") !== "undefined" && sessionStorage.getItem("user") !== "null"
      ? JSON.parse(sessionStorage.getItem("user"))
      : {};

  const saveUser = (user) => {
    sessionStorage.setItem("user", JSON.stringify(user));
  };

  const getAccessToken = () => localStorage.getItem("__at_um");
  const getRefreshToken = () => localStorage.getItem("__rt_um");

  const refreshAccessToken = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/authentication/refresh/`,
        { platform: "swm" },
        {
          withCredentials: true,
          headers: {
            "use-cookie-auth": "true",
          },
        }
      );
      saveTokens({ access: response.data.access, refresh: response.data.refresh });
      saveUser(response.data.user_data);
      return response.data.access;
    } catch (error) {
      console.error("Token refresh failed", error);
      throw error;
    }
  };

  const cleanUp = () => {
    localStorage.removeItem("__at_um");
    localStorage.removeItem("__rt_um");
    localStorage.removeItem("logged_user");
    sessionStorage.removeItem("user_permissions");
    sessionStorage.removeItem("user");
  };

  const cleanUpAndRedirect = () => {
    cleanUp();
    window.location.assign(`${ERM_APP_URL}`);
  };

  // const logout = async () => {
  //   const response = await axios.get(`${BASE_URL}/clear-authentication/`, {
  //     withCredentials: true,
  //     headers: {
  //       "use-cookie-auth": "true",
  //     },
  //   });
  //   if (response.status == 200) {
  //     cleanUp();
  //     window.location.assign(`${AUTH_URL}/sign-in`);
  //   }
  // };

  const logout = async () => {
    cleanUp(`${ERM_APP_URL}/logout`);
  };

  return {
    BASE_URL,
    saveTokens,
    saveUser,
    getAccessToken,
    getRefreshToken,
    refreshAccessToken,
    logout,
    user,
    cleanUp,
    cleanUpAndRedirect,
  };
};

export default useAuth;
